import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Loader } from 'src/components/atoms/Loader';
import { OwnerForm } from 'src/components/organisms/OwnerForm';
import { DetailView } from 'src/components/templates';
import useOwner from 'src/features/owner/hooks/useOwner';
import { IOwner, IOwnerRequest } from 'src/features/owner/ts/interfaces/Owner';

const OwnerCreatePage: React.FC = () => {
  const { onCreate, isCreating, createSuccess, owner } = useOwner();
  const navigate = useNavigate();

  const onSave = (owner: IOwner) => {
    onCreate({ owner: owner } as IOwnerRequest);
  };
  useEffect(() => {
    if (createSuccess && owner) {
      // Redirect to the owner list page after successful creation
      navigate('/owners');
    }
  }, [createSuccess, owner, navigate]);

  if (isCreating) {
    return <Loader />;
  }
  return (
    <DetailView back={{ to: '/owners', label: 'Go Back' }} title="Create Owner">
      <OwnerForm onSave={onSave} />
    </DetailView>
  );
};

export default OwnerCreatePage;
